import { CustomDialogProps } from '@/dashboard/components/Dialog/index';
import { EmojiSadIcon } from '@heroicons/react/outline';
import { formatCommonDateStr } from '@jove-frontend/uikit';
import { Box, Button, Typography } from '@mui/material';
import dayjs, { Dayjs } from 'dayjs';

type CancelPolicyDialogSuccessViewProps = CustomDialogProps & {
  submitInfo: {
    cancelDate: Dayjs;
  };
};
const CancelPolicyDialogSuccessView = (props: CancelPolicyDialogSuccessViewProps) => {
  const {
    submitInfo: { cancelDate },
    close,
  } = props;

  return (
    <Box className="mt-4 flex flex-col items-center">
      <Box className="bg-brand-secondary/20 text-brand-secondary rounded-full p-2">
        <EmojiSadIcon className="h-7 w-7" />
      </Box>
      <Typography className="text-black-secondary mt-4 text-center font-black" variant="h5">
        Your business insurance has been cancelled.
      </Typography>
      <Typography className="text-black-secondary mt-4 text-center font-medium" variant="subtitle1">
        Your policy will still be active till {formatCommonDateStr(cancelDate)}.
      </Typography>
      <Button className="mt-10 h-12 w-[210px] rounded-full text-lg font-bold" color="primary" onClick={close} variant="contained">
        Back to My policies
      </Button>
    </Box>
  );
};

export default CancelPolicyDialogSuccessView;
